import DoneAllIcon from '@material-ui/icons/DoneAll';

import List from './List';

export default {
  list: List,
  icon: DoneAllIcon,
};
